import { FormControl, FormControlLabel, Grid, Typography } from '@mui/material';
import styles from '../reportSection.module.scss'
import { CommonButton, CustomCalendarTodayOutlinedIcon, CustomCheckbox, CustomDatePicker, CustomMenuItem, CustomRequiredInputLabel, CustomSelectforFamily, StyledDateContainer } from '../../common/StyledComponents/StyledFields';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useState } from 'react';
import { ValidationError, object, string } from 'yup';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DietiesListByPoojaIdProps } from '../../../infrastructure/GlobalContextProvider';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';

const DailyReport = () => {
    interface ErrorMessageTypesPooja {
        pooja: string,
        searchbydonation: string
    }

    const formFieldsPoojaBooking = {
        pooja: "",
        searchbydonation: ""
    }
    const validationSchemaForpooja = object().shape({
        pooja: string().required('Pooja is required'),
        searchbydonation: string()
            .required('Search by Donation Date From is required'),
    });

    const [errorMessageBookPooja, setErrorMessageBookPooja] = useState<ErrorMessageTypesPooja>({ ...formFieldsPoojaBooking });

    const [formDataBookPooja, setFormDataBookPooja] = useState(formFieldsPoojaBooking);
    const errors: ErrorMessageTypesPooja = {
        ...formFieldsPoojaBooking
    }
    const [poojaDeitiesList, setPoojaDeitiesList] = useState<
        DietiesListByPoojaIdProps[]
    >([]);
    const [deityError, setDeityError] = useState<string>("");
    const [selectedDeityIds, setSelectedDeityIds] = useState<number[]>([]);

    const handleCheckboxChange = (label: number) => {
        const isSelected = selectedDeityIds.includes(label);
        setDeityError("");
        if (isSelected) {
            setSelectedDeityIds(selectedDeityIds.filter((item) => item !== label));
        } else {
            setSelectedDeityIds([...selectedDeityIds, label]);
        }
    };
    const poojaList = [
        {
            option: "option1"
        }
    ]
    const handlSubmitDailyreport = async () => {

        try {
            // Validate the form data against the validation schema
            await validationSchemaForpooja.validate(formDataBookPooja, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessageBookPooja(errors);
            // Call your API or perform other actions here
            // saveApiCall();

        } catch (error) {
            // Handle validation errors

            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypesPooja] = e.message;
                    }
                });
            }
            setErrorMessageBookPooja(errors);
        }
    }
    const PoojaListDropdown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        value={formDataBookPooja.pooja}
                        onChange={(e) => {
                            setErrorMessageBookPooja({ ...errorMessageBookPooja, pooja: '' });
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {poojaList.map((item: any, i: any) => (
                            <CustomMenuItem value={item.name} key={i}>
                                {item.name}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
                {errorMessageBookPooja.pooja && (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessageBookPooja.pooja}
                    </Typography>
                )}
            </>
        );
    };
    const DobDatePickerDailyReport = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
                <StyledDateContainer className={styles.styledConatiner}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataBookPooja.searchbydonation ? dayjs(formDataBookPooja.searchbydonation, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    setErrorMessageBookPooja({ ...errorMessageBookPooja, searchbydonation: '' });
                                }}
                                disableFuture
                                className={errorMessageBookPooja.searchbydonation ? styles.errorTextField : styles.dateFeildforfamily}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                    {errorMessageBookPooja.searchbydonation ? (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>
                            {errorMessageBookPooja.searchbydonation}
                        </Typography>
                    ) : (
                        ''
                    )}

                </StyledDateContainer>
            </div>
        );
    };
    const deitiesListComponent = () => {
        return (
            <div style={{ width: "100%" }}>
                {CustomRequiredInputLabel("Deities", true)}
                <div className={styles.checkBoxContainer}>
                    {poojaDeitiesList.map((item: DietiesListByPoojaIdProps, index) => (
                        <div className={styles.checkTitle}>
                            <FormControlLabel
                                control={
                                    <CustomCheckbox
                                        id={`${index}`}
                                        size="medium"
                                        className={styles.checkbox}
                                        checked={selectedDeityIds.includes(item.deityId)}
                                        onChange={() => handleCheckboxChange(item.deityId)}
                                    />
                                }
                                label={item.deityName}
                            />
                        </div>
                    ))}
                </div>
                {!isEmpty(deityError) ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {deityError}
                    </Typography>
                ) : (
                    ""
                )}
            </div>
        );
    };
    return (
        <div>
            <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={4}>
                    {CustomRequiredInputLabel("Pooja", true)}
                    {PoojaListDropdown()}
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={4}>
                    {CustomRequiredInputLabel("Search by Donation Date From", true)}
                    {DobDatePickerDailyReport()}
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={4}>
                    {deitiesListComponent()}
                </Grid>
            </Grid>
            <Grid sx={{ mt: 3 }}>
                <CommonButton onClick={handlSubmitDailyreport}>Submit</CommonButton>
            </Grid>
        </div>
    )
}
export default DailyReport;
